
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.788 20.858A2.45 2.45 0 007.214 23H17.79a2.449 2.449 0 002.426-2.142l1.275-10.174a2.444 2.444 0 00-2.427-2.75H17.49V6.99a4.99 4.99 0 00-9.975 0v.946H5.943a2.446 2.446 0 00-2.427 2.749l1.272 10.174zM9.01 6.99a3.489 3.489 0 016.975 0v.946H9.011v-.946zM5.234 9.754a.932.932 0 01.709-.32H7.51v1.791a.75.75 0 101.5 0v-1.79h6.975v1.79a.75.75 0 101.5 0v-1.79h1.568A.946.946 0 0120 10.498l-1.275 10.177a.947.947 0 01-.939.825H7.214a.947.947 0 01-.939-.825L5.004 10.498a.936.936 0 01.23-.744z","fill":"#7B61FF"}})])
          )
        }
      }
    